import { useStatusOverlay } from '@fs/zion-ui'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export type DataStatusOverlays = {
  showSuccess: (message: string) => void
  showError: (message?: string, error?: unknown) => void
}
export default function useDataStatusOverlay(): DataStatusOverlays {
  const [t] = useTranslation()

  const showStatus = useStatusOverlay()

  const showSuccess = useCallback(
    (message: string): void => showStatus({ message, type: 'success', transient: true }),
    [showStatus]
  )
  const showError = useCallback(
    (message?: string, error?: unknown): void => {
      showStatus({ message: message || t('tree-person.general.error'), type: 'error' })
      if (error) console.error(message, error)
    },
    [showStatus, t]
  )
  return { showSuccess, showError }
}

export function useSuccessOverlay(): DataStatusOverlays['showSuccess'] {
  return useDataStatusOverlay().showSuccess
}

export function useErrorOverlay(): DataStatusOverlays['showError'] {
  return useDataStatusOverlay().showError
}
